<template>
<div
    class="modal fade"
    id="kt_modal_hoodie_items"
    tabindex="-1"
    aria-hidden="true"
    data-bs-backdrop="false"
  >
  <!--begin::Modal header-->
    <div class="modal-dialog modal-dialog-centered mw-550px" > 
      <!--begin::Modal content-->
      <div class="modal-content">
        <!--begin::Modal header-->
        <div class="modal-header flex-stack">
          <!--begin::Title-->
          <h2>Order #{{ordernum}} ({{dzyn}})</h2>
          <!--end::Title-->
          <!--begin::Close-->
          <div
            class="btn btn-sm btn-icon btn-active-color-primary"
            data-bs-dismiss="modal" >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body scroll-y pt-10 pb-15 px-lg-17">
          <div class="card-body py-3">
            <!--begin::Table container-->
            <div class="table-responsive">
              <!--begin::Table-->
              <table class="table align-middle gs-0 gy-4">
                <!--begin::Table head-->
                <thead>
                  <tr class="fw-bolder text-muted bg-light">
                    <th class="ps-4 min-w-25px rounded-start">Size</th>
                    <th class="min-w-25px">Quantity</th>
                  </tr>
                </thead>
                <!--end::Table head-->
                <!--begin::Table body-->
                <tbody>
                  <template v-for="(item, index) in list" :key="index">
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;{{item.hoodie_size}}</td>
                      <td>&nbsp;&nbsp;&nbsp;{{item.hoodie_qty}}</td>
                      

                    </tr>
                  </template> 
                  <tr>
                      <td>&nbsp;&nbsp;&nbsp;<b>Total</b></td>
                      <td>&nbsp;&nbsp;&nbsp;<b>{{totalQty}}</b></td>
                      

                    </tr>
                </tbody>
                <!--end::Table body-->
              </table>
              <!--end::Table-->
            </div>
            <!--end::Table container-->
          </div>
        </div>
      </div>
    </div>
  </div>
   
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {viewExpiryDate}  from "@/api/estore";
import Swal from "sweetalert2/dist/sweetalert2.min.js";


export default defineComponent({
  name: "estore_expiry", 
  data(){
      return { 
        prodcode: "" as String,
        prodname: "" as String,
        expiry_list: [] as any
      }
  },
  methods: {
    async view_expiry_date(pcode, pname){
      
      
      
    }
  },
  mounted(){
      

  },
  components: {},
  props: {
    ordernum: Number,
    list: Object,
    dzyn : String,
    totalQty : Number
  }
});
</script>
